<div class="d-flex justify-content-between">
  <span class="text-nowrap">{{name}}</span>
  <div ngbDropdown style="min-width:4em; text-align: right;">
    <button [ngClass]="{'text-danger': selectedValue > -1}" class="btn btn-sm m-0 py-0 ms-auto" ngbDropdownToggle>
      <i class="fa fa-filter"></i>
    </button>
    <div class="p-2" style="width: 10rem;" ngbDropdownMenu>
      <select #control class="form-select">
        <option [value]="-1">Either</option>
        <option [value]="1">Yes</option>
        <option [value]="0">No</option>
      </select>
    </div>
  </div>
</div>
